import Logo from "../../../UI/Logo/Logo";
import Search from "./Search/Search";
import ShoppingCart from "./ShoppingCart/ShoppingCart";
import MyAccount from "./MyAccount/MyAccount";
import classes from "./Searchbar.module.css";

const Searchbar = () => {
  return (
    <div className={classes["search-bar"]}>
      <div className={classes["search-bar__search-container"]}>
        <Logo />
        <Search />
      </div>
      <div className={classes["search-bar__controls"]}>
        <ShoppingCart />
        <MyAccount />
      </div>
    </div>
  );
};

export default Searchbar;
